import { type DashRouteType, URL_APP_ADMIN } from '@retailer-platform/dashboard/route-patterns'

const URL_CUSTOM_STRINGS = `${URL_APP_ADMIN}/custom-strings`
const URL_CUSTOM_STRINGS_LIST = `${URL_CUSTOM_STRINGS}/list`
const URL_CUSTOM_STRINGS_DETAIL = `${URL_CUSTOM_STRINGS}/:resourceName/:resourceIdentifier`
const URL_CUSTOM_STRINGS_CREATE = `${URL_CUSTOM_STRINGS}/create`
const URL_CUSTOM_STRINGS_EDIT = `${URL_CUSTOM_STRINGS}/:resourceName/:resourceIdentifier/edit`
// @hygen:inject scoped-urls

export type DashRouteSet =
  | DashRouteType<'custom-strings'>
  | DashRouteType<'custom-strings-list'>
  | DashRouteType<'custom-strings-detail', { resourceName: string; resourceIdentifier: string }>
  | DashRouteType<'custom-strings-create'>
  | DashRouteType<'custom-strings-edit', { resourceName: string; resourceIdentifier: string }>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'custom-strings': URL_CUSTOM_STRINGS,
  'custom-strings-list': URL_CUSTOM_STRINGS_LIST,
  'custom-strings-detail': URL_CUSTOM_STRINGS_DETAIL,
  'custom-strings-create': URL_CUSTOM_STRINGS_CREATE,
  'custom-strings-edit': URL_CUSTOM_STRINGS_EDIT,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
